/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { Form } from "../shared/FormModel/FormModel";
import { SectionGroup } from "../shared/FormModel/elements/FormSectionGroup";
import { Section } from "../shared/FormModel/elements/FormSection";
import { Row } from "../shared/FormModel/elements/FormRow";
import { FieldText } from "../shared/FormModel/elements/FormFieldText";
import { FieldSelect } from "../shared/FormModel/elements/FormFieldSelect";
import { FieldLabel } from "../shared/FormModel/elements/FormFieldLabel";
import { HTMLContent } from "../shared/FormModel/elements/FormHTMLContent";

export const form_odskrtavaciSeznam = Form({
    id: "odskrtavaci-seznam",
    version: "2020-06-r1",
    title: "Odškrtávací seznam - pouze tisk",
    icon: "clipboard-check",
    showInMenu: true
}, [
    SectionGroup({}, [
        Section({
            id: "zakazka",
            title: "Zakázka"
        }, [
            Row({}, [
                FieldText({
                    width: "1/4",
                    id: "datum",
                    label: "Datum",
                    placeholder: "d.m.R",
                    required: true
                }),
                FieldText({
                    width: "3/4",
                    id: "zakaznik",
                    label: "Zákazník",
                    placeholder: "Jan Novák",
                    required: true
                })
            ]),
            Row({}, [
                FieldText({
                    id: "adresa_ulice",
                    label: "Ulice a č.p.",
                    placeholder: "Ulice 123",
                    required: true
                }),
                FieldText({
                    width: "2/6",
                    id: "adresa_mesto",
                    label: "Město",
                    placeholder: "Město",
                    required: true
                }),
                FieldText({
                    width: "1/6",
                    id: "adresa_psc",
                    label: "PSČ",
                    placeholder: "123 45",
                    required: true
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "kontakt_email",
                    label: "E-mail",
                    placeholder: "jan@novak.tld"
                }),
                FieldText({
                    width: "1/3",
                    id: "kontakt_telefon",
                    label: "Telefon",
                    placeholder: "+420 123 456 789"
                })
            ]),
            Row({}, [
                FieldText({
                    id: "realizace_misto",
                    label: "Místo realizace",
                    placeholder: "Adresa, město, PSČ"
                }),
                FieldText({
                    width: "1/6",
                    id: "realizace_patro",
                    label: "Patro",
                    placeholder: "1"
                }),
                FieldText({
                    width: "2/6",
                    id: "realizace_termin",
                    label: "Termín realizace",
                    placeholder: "d.m.R"
                })
            ]),
            Row({}, [
                FieldText({
                    id: "aktualni_stav",
                    label: "Aktuální stav",
                    placeholder: "Novostavba? Přestavba? Hotové instalace? Zdi?"
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "dalsi_informace",
                    label: "Další informace",
                    placeholder: "Počet lidí v domácnosti? Kdo a jak často vaříte?"
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "tvar_kuchyne",
                    label: "Tvar kuchyně",
                    placeholder: "..."
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "misto_pro_poznamky",
                    label: "Místo pro poznámky",
                    placeholder: ""
                })
            ])
        ]),
    ]),
    SectionGroup({}, [
        Section({
            id: "spotrebice",
            title: "Spotřebiče"
        }, [
            Row({
                id: "lednice"
            }, [
                FieldText({
                    id: "field-lednice-pozice",
                    width: "1/2",
                    label: "Lednice pozice",
                    value: "volně stojící - vestavná"
                }),
                FieldText({
                    id: "field-lednice-velikost",
                    width: "1/2",
                    label: "Lednice velikost",
                    value: "vysoká - pod PD - americká"
                })
            ]),
            Row({
                id: "mycka"
            }, [
                FieldText({
                    id: "field-mycka-pozice",
                    width: "1/3",
                    label: "Myčka pozice",
                    value: "volně stojící - vestavná"
                }),
                FieldText({
                    id: "field-mycka-sirka",
                    width: "1/3",
                    label: "Myčka šířka",
                    value: "450 mm - 600 mm"
                }),
                FieldText({
                    id: "field-mycka-panel",
                    width: "1/3",
                    label: "Myčka panel",
                    value: "integrovaná - ovládací panel"
                }),
            ]),
            Row({
                id: "vareni"
            }, [
                FieldText({
                    id: "field-vareni",
                    width: "1/2",
                    label: "Typ varné plochy",
                    value: "sklokeramicka - indukce - plyn"
                }),
                FieldText({
                    id: "field-trouba",
                    width: "1/2",
                    label: "Typ trouby",
                    value: "pod vaření - do výšky"
                }),
            ]),
            Row({
                id: "mvt"
            }, [
                FieldText({
                    id: "field-mvt-pozice",
                    width: "1/3",
                    label: "Mikrovlnná trouba pozice",
                    value: "volně stojící - vestavná"
                }),
                FieldText({
                    id: "field-mvt-rozmery",
                    width: "1/3",
                    label: "Mikrovlnná trouba rozměry",
                    value: "š. hl. v."
                }),
                FieldText({
                    id: "field-mvt-vyska",
                    width: "1/3",
                    label: "Mikrovlnná trouba do výšky",
                    value: "ano - ne"
                })
            ]),
            Row({
                id: "digestor"
            }, [
                FieldText({
                    id: "field-digestor-typ",
                    width: "1/3",
                    label: "Digestoř typ",
                    value: "komínová - vestavná"
                }),
                FieldText({
                    id: "field-digestor-sirka",
                    width: "1/3",
                    label: "Digestoř šířka",
                    value: "600 - 900"
                }),
                FieldText({
                    id: "field-digestor-odtah",
                    width: "1/3",
                    label: "Digestoř odtah",
                    value: "ano - ne"
                }),
            ]),
            Row({
                id: "drez"
            }, [
                FieldText({
                    id: "field-drez-typ",
                    width: "1/2",
                    label: "Dřez typ",
                    value: "s odkapem - jedna vana"
                }),
                FieldText({
                    id: "field-drez-material",
                    width: "1/2",
                    label: "Dřez materiál",
                    value: "nerez - granit - keramika"
                }),
            ]),
            Row({
                id: "baterie"
            }, [
                FieldText({
                    id: "field-baterie-typ",
                    width: "1/2",
                    label: "Baterie typ",
                    value: "stojánková - na zdi"
                }),
                FieldText({
                    id: "field-baterie-hlavice",
                    width: "1/2",
                    label: "Baterie hlavice",
                    value: "sprcha - klasika"
                }),
            ]),
            Row({
                id: "kos-osvetleni"
            }, [
                FieldText({
                    id: "field-kos-osvetleni",
                    width: "1/2",
                    label: "Koš",
                    value: "menší na dveře - třídění do výsuvu - vlastní"
                }),
                FieldText({
                    id: "field-kos-osvetleni-osvetleni",
                    width: "1/2",
                    label: "Osvětlení",
                    value: "zářivka - LED lišty - vlastní"
                }),
            ]),
            Row({
                id: "jine"
            }, [
                FieldText({
                    id: "dalsi_pozadavky",
                    label: "Další požadavky",
                    value: "Jiný spotřebič/požadavky? Robot? Velké spotřebiče? Potravinová skříň?"
                }),
            ]),
            Row({
                id: "jine"
            }, [
                FieldText({
                    id: "preferovana_znacka_spotrebicu",
                    label: "Preferovaná značka spotřebičů"
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "misto_pro_poznamky",
                    label: "Místo pro poznámky",
                    placeholder: ""
                })
            ])
        ])
    ]),
    SectionGroup({}, [
        Section({
            id: "provedeni_sestavy",
            title: "Provedení sestavy nábytku"
        }, [
            Row({
                id: "provedeni-sestavy-1"
            }, [
                FieldText({
                    id: "provedeni-sestavy-dvere",
                    width: "1/2",
                    label: "Dveře dekor",
                    value: "lamino - fólie - dýha - barva - masiv"
                }),
                FieldText({
                    id: "provedeni-sestavy-leta",
                    width: "1/2",
                    label: "Dveře dekor",
                    value: "vodorovně - horizontálně"
                }),
            ]),
            Row({
                id: "provedeni-sestavy-2"
            }, [
                FieldText({
                    id: "provedeni-sestavy-korpus",
                    width: "1",
                    label: "Korpus",
                    value: "lamino - dýha - barva"
                })
            ]),
            Row({
                id: "provedeni-sestavy-3"
            }, [
                FieldText({
                    id: "provedeni-sestavy-horni-skrinky",
                    width: "1/2",
                    label: "Otevírání horních skříněk",
                    value: "klasické - výklopné - lámací"
                }),
                FieldText({
                    id: "provedeni-sestavy-spodni-skrinky",
                    width: "1/2",
                    label: "Otevírání spodních skříněk",
                    value: "zásuvky - otevírací - výsuvné"
                })
            ]),
            Row({
                id: "provedeni-sestavy-4"
            }, [
                FieldText({
                    id: "provedeni-sestavy-pd",
                    width: "1/2",
                    label: "Pracovní deska",
                    value: "standardní 38 mm - corian - solidstone - přírodní kámen"
                }),
                FieldText({
                    id: "provedeni-sestavy-tl",
                    width: "1/2",
                    label: "Těsnící lišta",
                    value: ""
                })
            ]),
            Row({
                id: "provedeni-sestavy-5"
            }, [
                FieldText({
                    id: "provedeni-sestavy-obklad-za-linku",
                    width: "1",
                    label: "Obklad za linku",
                    value: "Egger 15 mm - sklo - dlaždička"
                })
            ]),
            Row({
                id: "provedeni-sestavy-6"
            }, [
                FieldText({
                    id: "provedeni-sestavy-sokl-provedeni",
                    width: "1",
                    label: "Sokl",
                    value: "120 mm - 150 mm - lamino - nerez - dýha"
                })
            ]),
            Row({
                id: "provedeni-sestavy-7"
            }, [
                FieldText({
                    id: "provedeni-sestavy-uchytka",
                    width: "1",
                    label: "Úchytka",
                    value: ""
                })
            ]),
            Row({
                id: "provedeni-sestavy-8"
            }, [
                FieldText({
                    id: "provedeni-sestavy-ramecek-u-skla",
                    width: "1",
                    label: "Rámeček u skla",
                    value: "AL - nerez - lamino - masiv - dýha"
                })
            ]),
            Row({
                id: "provedeni-sestavy-9"
            }, [
                FieldText({
                    id: "provedeni-sestavy-sklo",
                    width: "1",
                    label: "Sklo",
                    value: ""
                })
            ]),
            Row({
                id: "provedeni-sestavy-10"
            }, [
                FieldText({
                    id: "provedeni-sestavy-zasuvky",
                    width: "1",
                    label: "Zásuvky",
                    value: "částečný výsuv - plnovýsuv - boxside - rozdělovníky - protiskluzové dečky - příborník"
                })
            ]),
            Row({}, [
                FieldText({
                    id: "misto_pro_poznamky",
                    label: "Místo pro poznámky",
                    placeholder: ""
                })
            ])
        ])
    ]),
    SectionGroup({}, [
        Section({
            id: "rondo_kuchyne",
            title: "RONDO kuchyně"
        }, [
            Row({}, [
                FieldText({
                    id: "sklo",
                    label: "Sklo v kuchyni"
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "police",
                    label: "Police v kuchyni"
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "stul",
                    label: "Stůl v kuchyni"
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "potraviny",
                    label: "Uložení potravin"
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "misto_pro_poznamky",
                    label: "Místo pro poznámky",
                    placeholder: ""
                })
            ])
        ])
    ]),
    SectionGroup({}, [
        Section({
            id: "ostatni",
            title: "Ostatní"
        }, [
            Row({}, [
                FieldText({
                    id: "jak_se_o_nas_zakaznik_dozvedel",
                    label: "Jak se o nás zákazník dozvěděl?"
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "zmena_na_puvodni_lince",
                    label: "Co by chtěl změnit na původní lince?"
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "rozpocet",
                    label: "Rozpočet"
                }),
            ]),
            Row({}, [
                FieldText({
                    id: "poznamky",
                    label: "Další poznámky"
                }),
            ])
        ])
    ]),
    SectionGroup({}, [
        Section({
            id: "podpisova_sekce",
            title: "Potvrzení převzetí formuláře"
        }, [
            Row({
                id: "podpisy"
            }, [
                HTMLContent({}, (data) => <>
                    <table style={{
                        width: "100%"
                    }}>
                        <tr>
                            <td style={{
                                width: "50%",
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "15px",
                                paddingTop: "30px"
                            }}
                                colSpan={2}
                            >
                                V Českých Budějovicích, dne:
                            </td>
                        </tr>
                        <tr>
                            <td style={{
                                width: "50%",
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "15px",
                                paddingTop: "100px"
                            }}>
                                <p>
                                    . . . . . . . . . . . . . . . . . . . .
                                </p>
                                <p>
                                    <strong>Podpis a razítko<br />prodejce</strong>
                                </p>
                            </td>
                            <td style={{
                                width: "50%",
                                textAlign: "center",
                                verticalAlign: "middle",
                                padding: "15px",
                                paddingTop: "100px"
                            }}>
                                <p>
                                    . . . . . . . . . . . . . . . . . . . .
                                </p>
                                <p>
                                    <strong>Podpis<br />zákazníka</strong>
                                </p>
                            </td>
                        </tr>
                    </table>
                </>)
            ]),
        ])
    ])
]);